import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import styled from "styled-components";

const StlWrapper = styled.div`
  .text {
    display: inline-block;
    margin-right: 12px;
  }
`;

const StlFormControlLabel = styled(FormControlLabel)`
  margin-left: 12px;
  &.custom-label {
    position: relative;

    .MuiFormControlLabel-label {
      position: absolute;
      left: 10px;
      font-size: 12px;
      color: white;
    }

    &.label-disabled {
      .MuiFormControlLabel-label {
        color: #979797;
        right: 19px;
        left: auto;
      }
    }

    &.label-enabled {
      .MuiFormControlLabel-label {
        color: #ffffff !important;
      }
    }

    .MuiSwitch-track {
      background: #e0e0e0;
      opacity: 1;
    }

    .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
      background-color: #1070f8 !important;
      opacity: 1;
    }
  }
`;

export default function AccessibilitySwitch() {
  const dispatch = useDispatch();
  const handleChange = (event) => {
    dispatch({
      type: "ACCESSIBILITY/SAVE",
      show: event.target.checked,
    });
  };
  const showAccessibility = useSelector((state) =>
    get(state, "accessibility.show", false),
  );
  return (
    <StlWrapper>
      <span className="text">Site Accessibility:</span>
      <StlFormControlLabel
        control={
          <Switch
            checked={showAccessibility}
            onChange={handleChange}
            name="accessibility-switch"
            inputProps={{ "aria-label": "Toggle Accessibility" }}
            color="secondary"
            className="ada-switch mr-5"
          />
        }
        label={showAccessibility ? "On" : "Off"}
        className={
          showAccessibility
            ? "custom-label label-enabled"
            : "custom-label label-disabled"
        }
        labelPlacement="start"
      />
    </StlWrapper>
  );
}
